import { ComponentProps, ReactElement } from 'react';

import { getClasses } from '@/utils/strings';

export type SkyhopPdfFooterSectionHeaderProps = ComponentProps<'li'>;

const SkyhopPdfFooterSectionHeader = ({ ...props }: SkyhopPdfFooterSectionHeaderProps): ReactElement => (
  <li {...props} className={getClasses('SkyhopPdfFooter-Header', props.className)} />
);

export default SkyhopPdfFooterSectionHeader;
